<div class="table-section">
    <app-in-progress-forms-list></app-in-progress-forms-list>
</div>